import styled, { css } from 'styled-components';

import { Grid } from '@/components/Grid';

export const SwatchOption = styled.div`
  display: grid;
  justify-items: center;
  cursor: pointer;

  ${({ theme }) => css`
    padding: ${theme.spacing(1)};
    gap: ${theme.spacing(1)};
  `}
`;

const SwatchIconBase = styled.div`
  aspect-ratio: 1;
  border-radius: 50%;
  height: 24px;
  position: relative;
`;

export const IconWrapper = styled.div`
  position: relative;
  height: 24px;
  width: 24px;
`;

export const SwatchIcon = styled(SwatchIconBase)<{
  $background?: string;
  $backgroundImage?: string;
  $isGemSet?: boolean;
  $isRefined: boolean;
}>`
  ${({ $background, $backgroundImage }) =>
    css`
      background-image: url('${$backgroundImage}');
      background: ${$background};
    `};
  ${({ $isRefined, theme }) => css`
    font-size: ${theme.fontSizes.p4};
    &::after {
      content: ${$isRefined ? "'\\2714'" : "''"};
      color: ${$isRefined ? 'black' : 'transparent'};
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `}
  ${({ $isGemSet }) =>
    $isGemSet &&
    css`
      position: absolute;
      height: 18px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    `}
`;

export const Label = styled.div<{ isRefined: boolean }>`
  border-radius: 100px;
  text-align: center;
  ${({ isRefined, theme }) => css`
    background-color: ${isRefined ? theme.colors.primary : 'transparent'};
    padding: ${theme.spacing(1)};
    font-size: ${theme.fontSizes.p4};
  `}
`;
export const StyledGrid = styled(Grid)`
  grid-template-columns: repeat(4, 1fr);
`;
